import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["details", "ratingDef"];

  connect() {
    this.syncRequiredState();
    this.hydrateDefinition();
  }

  toggleDetails(event) {
    const checkbox = event.target;
    const detailsDiv = this.detailsTarget;

    if (checkbox.checked) {
      detailsDiv.classList.remove("hidden");
    } else {
      detailsDiv.classList.add("hidden");
      if (this.hasRatingDefTarget) {
        this.ratingDefTarget.classList.add("hidden");
        this.ratingDefTarget.innerHTML = "";
      }
      const radios = detailsDiv.querySelectorAll('input[type="radio"]');
      radios.forEach((r) => (r.checked = false));
    }
  }

  ratingChanged(event) {
    const radio = event.target;
    const short = radio.dataset.short || "";
    const definition = radio.dataset.definition || "";
    const value = radio.value;

    if (!this.hasRatingDefTarget) return;

    this.ratingDefTarget.innerHTML =
      `<strong>${value} \u2013 ${this.escapeHtml(short)}:</strong> ${this.escapeHtml(definition)}`;
    this.ratingDefTarget.classList.remove("hidden");
  }

  syncRequiredState() {
    const checkbox = this.element.querySelector(
      'input[type="checkbox"][name*="[selected]"]'
    );
    if (!checkbox) return;

    if (!checkbox.checked && this.hasDetailsTarget) {
      this.detailsTarget.classList.add("hidden");
    }
  }

  hydrateDefinition() {
    if (!this.hasRatingDefTarget) return;
    const checked = this.element.querySelector(
      'input[type="radio"][name*="[rating_value]"]:checked'
    );
    if (!checked) return;

    const short = checked.dataset.short || "";
    const definition = checked.dataset.definition || "";
    const value = checked.value;
    this.ratingDefTarget.innerHTML =
      `<strong>${value} \u2013 ${this.escapeHtml(short)}:</strong> ${this.escapeHtml(definition)}`;
    this.ratingDefTarget.classList.remove("hidden");
  }

  escapeHtml(text) {
    const div = document.createElement("div");
    div.textContent = text;
    return div.innerHTML;
  }
}
